/* eslint-disable generator-star-spacing */
/* eslint space-before-function-paren: "off" */
import { toast } from 'react-toastify'
import type { SagaIterator } from 'redux-saga'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Punchlist } from 'src/api'
import { campaignsActions } from 'src/ducks/actions'
import { errorTextTryingTo } from 'src/helpers'
import { campaignsTypes, FetchCampaignsAction } from './types'

export function* fetchCampaigns({ payload, callback }: FetchCampaignsAction): SagaIterator {

  let success = false
  try {
    const campaigns = yield call(Punchlist.campaigns.getCampaigns, payload)

    if (campaigns) {
      yield put(campaignsActions.setCampaigns(campaigns))
    }
    success = true
    if (callback) yield call(callback, success)
  } catch (error) {
    yield call(toast.error, errorTextTryingTo('get the discount banner'))
    if (callback) yield call(callback, false)
  }
}

export default function* saga(): SagaIterator {
  yield takeLatest(campaignsTypes.FETCH_CAMPAIGNS, fetchCampaigns)
}
